export const CATEGORIES = [
  {
    id: 'shoes',
    icon: 'footprints',
    label: 'Shoes',
    defaultGender: null,
    genders: ['men', 'women'],
  },
  {
    id: 'mens-clothing',
    icon: 'shirt',
    label: "Men's Clothing",
    defaultGender: 'men',
    genders: ['men'],
  },
  {
    id: 'womens-clothing',
    icon: 'sparkles',
    label: "Women's Clothing",
    defaultGender: 'women',
    genders: ['women'],
  },
  {
    id: 'jeans',
    icon: 'ruler',
    label: 'Jeans & Pants',
    defaultGender: null,
    genders: ['men', 'women'],
  },
  {
    id: 'kids-shoes',
    icon: 'baby',
    label: "Kids' Shoes",
    defaultGender: 'kids',
    genders: ['kids'],
  },
];

export const GENDERS = [
  { id: 'men', label: 'Men' },
  { id: 'women', label: 'Women' },
];

export function getCategoryById(id) {
  return CATEGORIES.find((c) => c.id === id);
}
